import { useCallback } from 'react';
import { useAppDispatch, useAppSelector } from '../index.ts';
import { setSidePanelLoading } from '../../store/slices/uiSlice.ts';

/**
 * Hook to manage loading state for SidePanel content
 * Forms can use this to report when they are loading catalog data
 */
export const useSidePanelLoading = () => {
  const dispatch = useAppDispatch();
  const isPanelOpen = useAppSelector((state) => state.ui.sidePanel?.open ?? false);

  const setLoading = useCallback(
    (loading: boolean) => {
      dispatch(setSidePanelLoading(loading));
    },
    [dispatch],
  );

  return { setLoading, isPanelOpen };
};
